<mat-card data-at-feature-value-modal>
  <mat-card-header>
    <mat-card-title class="!flex flex-row justify-between items-center">
      <div class="grid gap-[8px]">
        <div>{{ data.title | translate }}</div>
        <div class="description">
          {{ data.inputSettings.name | translate }}
          <span *ngIf="data.inputSettings.unit"> {{ data.inputSettings.unit }} </span>
        </div>
      </div>
      <button
        data-at-close-feature-value-modal
        mat-icon-button
        gtm="onClose"
        [gtmAction]="data.inputSettings.actionNameForGTM"
        [gtmCategory]="data.categoryNameForGTM"
        (click)="onClose()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content class="!flex flex-row gap-[16px] justify-start items-center">
    <mat-form-field
      mat-input-height-large-label
      class="flex-1"
      [class.error]="featureValueControl.invalid"
    >
      <input
        gtm="onTextField"
        [gtmAction]="data.inputSettings.actionNameForGTM"
        [gtmCategory]="data.categoryNameForGTM"
        [gtmOn]="['change', 'focus', 'blur']"
        class="flex-1"
        data-at-feature-value-input
        matInput
        autocomplete="off"
        [formControl]="featureValueControl"
        [errorStateMatcher]="matcher"
        [min]="data.inputSettings.min"
        [max]="data.inputSettings.max"
        fieldTextContentTooltip
      />
      <button
        *ngIf="featureValueControl.value"
        matSuffix
        mat-icon-button
        gtm="onCancel"
        [gtmAction]="data.inputSettings.actionNameForGTM"
        [gtmCategory]="data.categoryNameForGTM"
        (click)="onClear()"
      >
        <mat-icon>cancel</mat-icon>
      </button>
      <mat-error *ngIf="data.inputSettings.isRequired && featureValueControl.hasError('required')">
        {{ data.errorText.required | translate }}
      </mat-error>
      <mat-error *ngIf="data.inputSettings.pattern && featureValueControl.hasError('pattern')">
        {{ data.errorText.pattern | translate }}
      </mat-error>
      <mat-error *ngIf="data.inputSettings.min && featureValueControl.hasError('min')">
        {{ data.errorText.min | translate: { minValue: data.inputSettings?.min } }}
      </mat-error>
      <mat-error *ngIf="data.inputSettings.max && featureValueControl.hasError('max')">
        {{ data.errorText.max | translate: { maxValue: data.inputSettings.max } }}
      </mat-error>
      <mat-error *ngIf="data.inputSettings.step && featureValueControl.hasError('step')">
        {{ data.errorText.step | translate: { stepValue: data.inputSettings.step } }}
      </mat-error>
    </mat-form-field>
    <button
      class="save-btn lt-md:!hidden flex-[150px] max-w-[150px]"
      data-at-save-feature-value-modal
      mat-raised-button
      gtm="onSave"
      [gtmAction]="data.inputSettings.actionNameForGTM"
      [gtmCategory]="data.categoryNameForGTM"
      color="primary"
      [disabled]="!featureValueControl.valid || !isFeatureValueChanged()"
      (click)="onSaveFeatureValue()"
    >
      {{ 'GENERAL.BUTTON.SAVE' | translate }}
    </button>
  </mat-card-content>
  <mat-card-actions class="flex flex-col gap-[8px] gt-sm:!hidden justify-start items-center">
    <button
      data-at-save-feature-value-modal
      mat-raised-button
      gtm="onSave"
      [gtmAction]="data.inputSettings.actionNameForGTM"
      [gtmCategory]="data.categoryNameForGTM"
      color="primary"
      [disabled]="!featureValueControl.valid || !isFeatureValueChanged()"
      (click)="onSaveFeatureValue()"
    >
      {{ 'GENERAL.BUTTON.SAVE' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
